var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBank = function SvgBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.707 4.707A1 1 0 0 1 14 5H2a1 1 0 0 1-.395-1.92L7.21.16a2 2 0 0 1 1.58 0l5.595 2.92a.314.314 0 0 1 .115.08A1 1 0 0 1 15 4a1 1 0 0 1-.293.707ZM11 7v5a1 1 0 0 0 2 0V7a1 1 0 0 0-2 0Zm3.707 7.293A1 1 0 0 0 14 14H2a1 1 0 0 0 0 2h12a1 1 0 0 0 .707-1.707ZM7 12V7a1 1 0 0 1 2 0v5a1 1 0 1 1-2 0ZM3 7v5a1 1 0 1 0 2 0V7a1 1 0 0 0-2 0Z"
  })));
};
export default SvgBank;